import { maijia } from "./zh/maijia";
import { home } from "./zh/home";
export default {
	maijia,
	home
};
